var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3002 10.7595L13.22 22.558C12.6665 23.1473 11.769 23.1473 11.2153 22.558C10.6619 21.9684 10.6619 21.0127 11.2153 20.4234L22.2955 8.62493H17.5501C16.8045 8.62493 16.2002 7.98144 16.2002 7.1875C16.2002 6.39356 16.8045 5.75007 17.5501 5.75007H25.6501C26.3957 5.75007 27 6.39356 27 7.1875V15.8126C27 16.6065 26.3957 17.25 25.6501 17.25C24.9045 17.25 24.3002 16.6065 24.3002 15.8126V10.7595ZM2.69984 12.2405L13.78 0.442022C14.3335 -0.147341 15.231 -0.147341 15.7847 0.442022C16.3381 1.03163 16.3381 1.98726 15.7847 2.5766L4.70447 14.3751H9.4499C10.1955 14.3751 10.7998 15.0186 10.7998 15.8125C10.7998 16.6064 10.1955 17.2499 9.4499 17.2499H1.34992C0.604316 17.2499 0 16.6064 0 15.8125V7.18744C0 6.3935 0.604316 5.75001 1.34992 5.75001C2.09552 5.75001 2.69984 6.3935 2.69984 7.18744V12.2405Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.f2f00db59bb891ffe6102b907b455bbf.svg";
export { ForwardRef as ReactComponent };